<script>
import { mapGetters, mapActions } from "vuex";
import appConfig from "@/app.config";
import { debounce } from "../../../state/helpers";
import { formatIST } from "../../../config/moment";

export default {
  page: {
    title: "User-Wallet-Transaction",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      search: "",
      formatIST,
      id: "",
      booking: {
        is_cancel: [],
      },
      typeform: {
        selectedCharger: [],
      },
      searchData: debounce(() => {
        this.getMyWalletTransaction();
        this.init = false;
      }, 500),
      chargerList: [],
      fields: [
        { key: "id", sortable: true, label: "ID" },
        { key: "description", sortable: false, label: "Description" },
        { key: "created_at", sortable: true, label: "Transaction Time" },
        { key: "source", sortable: true, label: "Method" },
        { key: "transaction_id", sortable: false, label: "Transaction Id" },
        { key: "credit", sortable: false, label: "Credit" },
        { key: "debit", sortable: false, label: "Debit" },
      ],
    };
  },
  props: ["userId"],
  components: {},
  validations: {},
  computed: {
    ...mapGetters("userWallet", [
      "loading",
      "pagination",
      "walletTransactionCount",
      "walletTransactions",
      "walletAmount",
    ]),
  },
  mounted() {
    this.getMyWalletTransaction();
  },
  methods: {
    ...mapActions("userWallet", ["getWalletTransaction"]),
    getMyWalletTransaction(page = 1) {
      var filters = {
        search: this.search,
        sort_by: this.sortBy,
        order_by: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        limit: this.perPages,
        user_id: this.convertDecodeId(this.$route.params.id),
      };
      this.getWalletTransaction(filters);
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getMyWalletTransaction();
    },
    convertDecodeId(id) {
      return (this.user_id = atob(id));
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-end mb-3">
        <h4 class="card-title">Wallet Balance: ₹{{ walletAmount }}</h4>
      </div>
      <form action="#" @submit.prevent="typeForm">
        <div class="card details-profile-main">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div
                  class="pb-0 page-title-box d-flex align-items-center justify-content-between icon-main-page"
                >
                  <h4 class="card-title page-title-left">
                    Transactions ({{ walletTransactionCount }})
                  </h4>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row justify-content-end">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <div class="date-range-list">
                        <label>Per Page :</label>
                        <select class="custom-select" v-model="perPages" @change="searchData()">
                          <option value="5" selected>5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="date-range-list">
                      <label>Search :</label>
                      <div class="text-sm-right">
                        <div class="search-box mr-2 d-inline-block">
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control"
                              id="search"
                              @input="searchData()"
                              v-model="search"
                              :placeholder="$t('navbar.search.text')"
                            />
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-table
                  striped
                  hover
                  :items="walletTransactions"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :fields="fields"
                  :busy="loading"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(created_at)="items">
                    {{ formatIST(items.item.created_at) }}
                  </template>
                  <template v-slot:cell(credit)="items">
                    <span v-if="items.item.type === 'credit'">₹{{ items.item.amount }}</span>
                  </template>
                  <template v-slot:cell(debit)="items">
                    <span v-if="items.item.type === 'debit'">₹{{ items.item.amount }}</span>
                  </template>
                </b-table>
                <tr v-if="loading == false && walletTransactions.length === 0">
                  <td colspan="100%">
                    <h6 align="center">No Booking Data Found</h6>
                  </td>
                </tr>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="perPages"
                        @pagination-change-page="getMyWalletTransaction"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
